module.exports = __webpack_public_path__ + "static/img/ltlogo-footer.1347707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ltlogo-footer.png
// module id = S7m7
// module chunks = 15